import * as angular from 'angular';

export class PercentFormatFilter {
	public static Factory() {
		const factoryFunc = () => {
			return (input) => {
				return angular.isDefined(input) ? input + "%" : "";
			}
		}
		return factoryFunc;
	}
}

//export function pfmt() {
//	return (input) => {
//		return angular.isDefined(input) ? input + "%" : "";
//	}
//}

export default angular
	.module('aps.filters', [])
	.filter('pfmt', PercentFormatFilter.Factory())
	.name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/filters/pfmt.filter.ts